import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Radio } from "antd";
import { get, post, responseValidator, SERVER, SITEURL } from "../../../api";
import NumberFormat from "react-number-format";
import CircularProgress from "@material-ui/core/CircularProgress";
import btcSVG from "../../../landing/pic/btc.svg";
import irrSVG from "../../../landing/pic/irr.svg";
import axios from "axios";
import ethSVG from "../../../landing/pic/eth.svg";
import "./index.scss";
import Loading from "../../../loading/loading.index";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import useOnBlur from "../../../util/useOnBlue";
import { Modal } from "antd";
let destination = "BTC";
let sOurce = "IRT";

export function checkIsLogin() {

    if (
        localStorage.getItem("accessToken") &&
        localStorage.getItem("accessToken").length > 0
    ) {
        let lastRefresh = localStorage.getItem("tokenDate");
        return true;
    }
    return false;
}
export default function Order() {
    const [active, setActive] = useState(1);
    const [isOpen, setOpen] = useState(false);
    const [isOpen2, setOpen2] = useState(false);
    const [name, setName] = useState("BTC");
    const [sType, setSType] = useState(1);
    const [dType, setDType] = useState(3);
    const [name2, setName2] = useState("IRT");
    const [subname, setSubname] = useState("بیت کوین");
    const [subname2, setSubname2] = useState("ریال\nایران");
    const [svg, setSvg] = useState(btcSVG);
    const [svg2, setSvg2] = useState(irrSVG);
    const [markets, setMarkets] = useState([]);
    const [marketstatic, setMarketsStatic] = useState([]);
    const source = useRef();
    const inputRef2 = useRef();
    const inputRef = useRef();
    const [exChange, setexChange] = useState(undefined);
    const [process, setProcess] = useState();
    const [inputValue, setInputValue] = useState(undefined);
    const [pageLoading, setPageLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const sourceDropDownRef = useRef();
    const [firstInput, setFirstInput] = useState(undefined);
    const [process1, setProcess1] = useState(false);
    const [process2, setProcess2] = useState(false);
    const [visible, setVisible] = useState(false);
    const source1 = useRef();
    const source2 = useRef();
    const [secondInput, setSecondInput] = useState(undefined);
    const destinationDropDownRef = useRef();
    const intervalRef = useRef(null);

    useOnBlur(sourceDropDownRef, () => {
        if (isOpen) setOpen(false);
    });
    useOnBlur(destinationDropDownRef, () => {
        if (isOpen2) setOpen2(false);
    });

    function searchHandler(event) {
        let newList = [];
        if (event.target.value !== "") {
            newList = marketstatic.filter(item => {
                const name = item.name.toLowerCase();
                const symbol = item.symbol.toLowerCase();
                const filter = event.target.value.toLowerCase();
                return name.includes(filter) || symbol.includes(filter);
            });
            setMarkets(newList);
        } else {
            setMarkets(marketstatic);
        }
    }

    function searchHandler2(event) {
        let newList = [];
        if (event.target.value !== "") {
            newList = marketstatic.filter(item => {
                const name = item.name.toLowerCase();
                const symbol = item.symbol.toLowerCase();
                const filter = event.target.value.toLowerCase();
                return name.includes(filter) || symbol.includes(filter);
            });
            newList = newList.filter(item => item.symbol !== sOurce);
            setMarkets(newList);
        } else {
            setMarkets(marketstatic);
        }
    }

    function xToyValue(which, e) {
        let _firsInput;
        let _secondInput;
        if (which === 1) {
            // _firsInput = source1.current.value.replaceAll(',', '');
            _firsInput = e;
            setFirstInput(_firsInput);
            // setProcess2(true);
        } else {
            //_secondInput = source2.current.value.replaceAll(',', '')
            _secondInput = e;
            setSecondInput(_secondInput);
            // setProcess1(true)
        }

        if ((which === 1 && _firsInput) || (which === 2 && _secondInput)) {
            if (intervalRef.current) {
                clearTimeout(intervalRef.current);
            }
            //return null
            // console.log(which,e.floatValue)

            if (which === 1) {
                // _firsInput = source1.current.value.replaceAll(',', '');
                // _firsInput = e
                //   setFirstInput(_firsInput)
                setProcess2(true);
            } else {
                //_secondInput = source2.current.value.replaceAll(',', '')
                // _secondInput = e
                //  setSecondInput(_secondInput)
                setProcess1(true);
            }
            console.log(which, _firsInput, _secondInput);

            let amount;
            if (which === 1) amount = _firsInput;
            else amount = _secondInput;

            intervalRef.current = setTimeout(() => {
                axios
                    .get(
                        SERVER +
                        `/Market/Exchange/${amount}/${sOurce}/${destination}/${which}/`,
                        "accept: text/plain"
                    )
                    .then(res => {
                        // console.log(res.data.data.destinationAmount);
                        setProcess1(false);
                        setProcess2(false);
                        if (which === 1) {
                            //  console.log(numberWithCommas(res.data.data.destinationAmount.toFixed(12)))
                            setSecondInput(
                                numberWithCommas(
                                    res.data.data.destinationAmount
                                )
                            );
                            //source2.current.value=numberWithCommas(res.data.data.destinationAmount.toFixed(12))
                        } else
                            setFirstInput(
                                numberWithCommas(res.data.data.sourceAmount)
                            );
                    });
                intervalRef.current = null;
            }, 500);
        } else {
            if (which === 1) setSecondInput(null);
            else setFirstInput(null);
        }
    }

    function numberWithCommas(x) {
        //   return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        return x;
    }

    useEffect(() => {
        checkIsLogin();
        get("/user/ping").then(response => {
            if (responseValidator(response.status)) {
            }
        });
        axios.get(SERVER + "/Market", "accept: text/plain").then(res => {
            setPageLoading(false);
            setMarkets(res.data.data);
            setMarketsStatic(res.data.data);
        });
    }, []);

    useEffect(() => {
        if (active === 1) {
            setName("IRT");
            setSType(3);
            setSubname("تومان\nایران");
            setSvg(irrSVG);
            setName2("BTC");
            setDType(1);
            setSubname2("بیت کوین");
            setSvg2(btcSVG);
        } else if (active === 2) {
            setName2("IRT");
            setDType(3);
            setSubname2("تومان\nایران");
            setSvg2(irrSVG);
            setSvg(btcSVG);
            setName("BTC");
            setSType(1);
            setSubname("بیت کوین");
        } else {
            setName2("ETH");
            setDType(1);
            setSubname2("اتریوم");
            setSvg2(ethSVG);
            setName("BTC");
            setSType(1);
            setSvg(btcSVG);
            setSubname("بیت کوین");
        }
    }, [active]);

    useEffect(() => {
        if (inputValue === "") setexChange(undefined);
    }, [exChange]);

    function changeHandler(e) {
        e = e.target.value;
        setActive(e);
        setOpen(false);
        if (e === 1) {
            sOurce = "IRT";
            destination = "BTC";
        } else if (e === 2) {
            sOurce = "BTC";
            destination = "IRT";
        } else {
            sOurce = "BTC";
            destination = "ETH";
        }
        setFirstInput("");
        setSecondInput("");
    }

    function onSubmitHandler() {
        setButtonLoading(true);
        // console.log(firstInput,firstInput.replaceAll(',', ''),parseFloat(firstInput.replaceAll(',', '')))
        const body = {
            sourceMarket: name,
            platform: 0,
            amount: parseFloat(firstInput),
            destinationMarket: name2
        };
        post("/Order/Create", body).then(res => {
            setButtonLoading(false);
            if (responseValidator(res.status)) {
                console.log(res);
                // toast.success(res.data.message)
                localStorage.setItem("order", res.data.data.trackingCode);
                if (sType === 3 && dType === 1)
                    window.location.replace("/userpanel/order/IRTC/");
                if (sType === 1 && dType === 3)
                    window.location.replace("/userpanel/order/CIRT/");
                if (sType === 1 && dType === 1)
                    window.location.replace("/userpanel/order/CC/");
                if (sType === 3 && dType === 2)
                    window.location.replace("/userpanel/order/IRTM/");
                if (sType === 1 && dType === 2)
                    window.location.replace("/userpanel/order/CM/");
                if (sType === 2 && dType === 3)
                    window.location.replace("/userpanel/order/MIRT/");
                if (sType === 2 && dType === 1)
                    window.location.replace("/userpanel/order/MC/");
            } else {
                res.data.message ===
                    "قبل از خرید و فروش ریالی لطفا حساب بانکی خود را اضافه کنید"
                    ? warning(res.data.message)
                    : toast.error(res.data.message);
            }
        });
    }
    const hideModal = () => {
        setVisible(false);
    };

    const warning = message => {
        Modal.warning({
            title: message,
            content: "جهت افزودن حساب بانکی بر روی دکمه زیر کلیک کنید.",
            okText: "افزودن حساب بانکی",
            cancelText: "انصراف",
            onOk: () => {
                window.open(window.open("/userpanel/addCard/", "_blank"));
            },
            closable: true,
            onCancel: () => {
                return false;
            }
        });
    };

    return (
        <div>
            {pageLoading && <Loading />}
            <Card title="خرید/فروش">
                <div className="Tmex-order-page">
                    <Radio.Group onChange={changeHandler} value={active}>
                        <Radio value={1}>خرید</Radio>
                        <Radio value={2}>فروش</Radio>
                        <Radio value={3}>تبدیل</Radio>
                    </Radio.Group>

                    <div className="underTop">
                        <div className="body-items">
                            {/*azinja shoro mishe*/}
                            {active === 2 || active === 3 ? (
                                <div
                                    ref={sourceDropDownRef}
                                    className={`drop-down-toggling ${isOpen ? "opened" : ""
                                        }`}
                                >
                                    <div>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                backgroundColor: "white",
                                                borderBottom: "1px solid black"
                                            }}
                                        >
                                            <i
                                                className="fas fa-search"
                                                style={{
                                                    marginRight: "23px",
                                                    marginLeft: "5px",
                                                    color: "gray",
                                                    fontSize: "17px"
                                                }}
                                            />
                                            <input
                                                className="input"
                                                type="type/text"
                                                placeholder="جستجو"
                                                ref={inputRef2}
                                                onChange={searchHandler}
                                            />
                                        </div>
                                        {markets &&
                                            markets
                                                .filter(
                                                    item =>
                                                        item.symbol !==
                                                        destination
                                                )
                                                .map(item => (
                                                    <div
                                                        className="dd-items"
                                                        onClick={() => {
                                                            setSvg(
                                                                SITEURL +
                                                                `${item.icon}`
                                                            );
                                                            setName(
                                                                item.symbol
                                                            );
                                                            setSType(item.type);
                                                            sOurce =
                                                                item.symbol;
                                                            setSubname(
                                                                item.name
                                                            );
                                                            inputRef2.current.value =
                                                                "";
                                                            setTimeout(
                                                                () =>
                                                                    setMarkets(
                                                                        marketstatic
                                                                    ),
                                                                300
                                                            );
                                                            setOpen(!isOpen);
                                                            xToyValue(
                                                                1,
                                                                firstInput
                                                            );
                                                        }}
                                                    >
                                                        <div className="icon-svg-dd">
                                                            <img
                                                                style={{
                                                                    minWidth:
                                                                        "35px",
                                                                    minHeight:
                                                                        "35px",
                                                                    maxWidth:
                                                                        "35px",
                                                                    maxHeight:
                                                                        "35px"
                                                                }}
                                                                src={
                                                                    SITEURL +
                                                                    `${item.icon}`
                                                                }
                                                                alt={
                                                                    item.symbol
                                                                }
                                                            />
                                                        </div>
                                                        <div className="name-info-dd">
                                                            <p className="subName-info-dd">
                                                                {item.name +
                                                                    "   " +
                                                                    "(" +
                                                                    item.symbol +
                                                                    ")"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {/*inja dg nmitoone drop downo baz kone*/}

                            {/*azinja statice avalesh shoro mishe*/}
                            <div className="rows">
                                <div
                                    className="digitalCurrencies"
                                    onClick={() => setOpen(!isOpen)}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex"
                                        }}
                                    >
                                        <div className="icon-svg">
                                            <img
                                                style={{
                                                    minWidth: "35px",
                                                    minHeight: "35px",
                                                    maxWidth: "35px",
                                                    maxHeight: "35px"
                                                }}
                                                src={svg}
                                                alt="bitcoin"
                                            />
                                        </div>
                                        <div className="name-info">
                                            {name}
                                            <p className="subName-info">
                                                {subname}
                                            </p>
                                        </div>
                                    </div>
                                    {/*in iconam bayad sickesh zade she*/}
                                    {active === 2 || active === 3 ? (
                                        <i
                                            className="fas fa-caret-down dropdown-icon"
                                            dir="ltr"
                                        />
                                    ) : (
                                        ""
                                    )}
                                    {/*in iconam bayad sickesh zade she*/}
                                </div>
                                <div className="cash-input" dir="ltr">
                                    <p className="cash">واحد</p>

                                    {/*<input*/}
                                    {/*    lang="fa"*/}
                                    {/*    dir="ltr"*/}
                                    {/*    type="number"*/}
                                    {/*    onChange={xToyValue}*/}
                                    {/*/>*/}
                                    {process1 ? (
                                        <CircularProgress
                                            style={{
                                                // minWidth: "25px",
                                                // minHeight: "25px",
                                                // maxHeight: "25x",
                                                // maxWidth: "25px",
                                                width: "23px",
                                                height: "23px",
                                                color: "white"
                                            }}
                                        />
                                    ) : (
                                        <NumberFormat
                                            onChange={e =>
                                                xToyValue(
                                                    1,
                                                    e.target.value.replaceAll(
                                                        ",",
                                                        ""
                                                    )
                                                )
                                            }
                                            // onValueChange={(e) => xToyValue(1, e)}
                                            className={
                                                active === 1
                                                    ? "inputPlace"
                                                    : "inputPlace2"
                                            }
                                            inputmode="numeric"
                                            thousandSeparator={true}
                                            getInputRef={source1}
                                            value={firstInput}
                                        />
                                    )}
                                </div>
                            </div>
                            {/*inja statice avalesh tamoom mishe*/}
                        </div>
                        {/*dovomi*/}

                        <div className="body-items">
                            {/*azinja shoro mishe*/}
                            {active === 1 || active === 3 ? (
                                <div
                                    ref={destinationDropDownRef}
                                    className={`drop-down-toggling ${isOpen2 ? "opened" : ""
                                        }`}
                                >
                                    <div>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                backgroundColor: "white",
                                                borderBottom: "1px solid black"
                                            }}
                                        >
                                            <i
                                                className="fas fa-search"
                                                style={{
                                                    marginRight: "23px",
                                                    marginLeft: "5px",
                                                    color: "gray",
                                                    fontSize: "17px"
                                                }}
                                            />
                                            <input
                                                className="input"
                                                ref={inputRef}
                                                type="type/text"
                                                placeholder="جستجو"
                                                onChange={searchHandler2}
                                            />
                                        </div>
                                        {markets &&
                                            markets
                                                .filter(
                                                    item =>
                                                        item.symbol !== sOurce
                                                )
                                                .map(item => (
                                                    <div
                                                        className="dd-items"
                                                        onClick={() => {
                                                            setSvg2(
                                                                SITEURL +
                                                                `${item.icon}`
                                                            );
                                                            setName2(
                                                                item.symbol
                                                            );
                                                            setDType(item.type);
                                                            destination =
                                                                item.symbol;
                                                            inputRef.current.value =
                                                                "";
                                                            setTimeout(
                                                                () =>
                                                                    setMarkets(
                                                                        marketstatic
                                                                    ),
                                                                300
                                                            );
                                                            setSubname2(
                                                                item.name
                                                            );
                                                            setOpen2(!isOpen2);
                                                            xToyValue(
                                                                1,
                                                                firstInput
                                                            );
                                                        }}
                                                    >
                                                        <div className="icon-svg-dd">
                                                            <img
                                                                style={{
                                                                    width:
                                                                        "35px",
                                                                    height:
                                                                        "35px"
                                                                    // borderRadius: "100%"
                                                                }}
                                                                src={
                                                                    SITEURL +
                                                                    `${item.icon}`
                                                                }
                                                                alt={
                                                                    item.symbol
                                                                }
                                                            />
                                                        </div>
                                                        <div className="name-info-dd">
                                                            <p className="subName-info-dd">
                                                                {item.name +
                                                                    "   " +
                                                                    "(" +
                                                                    item.symbol +
                                                                    ")"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {/*inja dg nmitoone drop downo baz kone*/}

                            <div className="rows">
                                <div
                                    className="digitalCurrencies"
                                    onClick={() => {
                                        setOpen2(!isOpen2);
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display:
                                                "flex" /*position: "relative"} /*flex: 1}*/
                                        }}
                                    >
                                        <div className="icon-svg">
                                            <img
                                                style={{
                                                    minWidth: "35px",
                                                    minHeight: "35px",
                                                    maxWidth: "35px",
                                                    maxHeight: "35px"
                                                }}
                                                src={svg2}
                                                alt="bitcoin"
                                            />
                                        </div>
                                        <div className="name-info">
                                            {name2}
                                            <p className="subName-info">
                                                {subname2}
                                            </p>
                                        </div>
                                    </div>
                                    {/*in iconam bayad sickesh zade she*/}
                                    {active === 1 || active === 3 ? (
                                        <i
                                            className="fas fa-caret-down dropdown-icon"
                                            dir="ltr"
                                        />
                                    ) : (
                                        ""
                                    )}
                                    {/*in iconam bayad sickesh zade she*/}
                                </div>
                                <div className="cash-input" dir="ltr">
                                    <p className="cash-readOnly">واحد</p>
                                    {process2 ? (
                                        <CircularProgress
                                            style={{
                                                // minWidth: "25px",
                                                // minHeight: "25px",
                                                // maxHeight: "25x",
                                                // maxWidth: "25px",
                                                width: "23px",
                                                height: "23px",
                                                color: "white"
                                            }}
                                        />
                                    ) : (
                                        <NumberFormat
                                            onChange={e =>
                                                xToyValue(
                                                    2,
                                                    e.target.value.replaceAll(
                                                        ",",
                                                        ""
                                                    )
                                                )
                                            }
                                            // onValueChange={(e) => xToyValue(2, e)}
                                            className={
                                                active === 1
                                                    ? "inputPlace"
                                                    : "inputPlace2"
                                            }
                                            inputmode="numeric"
                                            thousandSeparator={true}
                                            value={secondInput}
                                            getInputRef={source2}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-btn">
                        <Button
                            disabled={!firstInput || !secondInput}
                            loading={buttonLoading}
                            onClick={onSubmitHandler}
                            type={"primary"}
                        >
                            ادامه
                        </Button>
                    </div>
                </div>
                <ToastContainer
                    dir="rtl"
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    draggable
                    style={{ fontSize: "13px" }}
                />
            </Card>
        </div>
    );
}
